import { Box, MenuItem, Typography, Select } from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: 8,
  },
  label: {
    color: "#8A8F9C",
    fontSize: 11,
    fontWeight: "600",
    marginBottom: 3,
  },
  customSelect: {
    backgroundColor: "#fff",
    color: "#15171E",
    fontSize: 12,
    fontWeight: "600",
    height: 34,
    borderRadius: 10,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E4E6EC",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D8DBE2",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#B4B8C2",
      borderWidth: 1,
    },
  },
}));

const CustomComboBox = ({
  label,
  onChange,
  items,
  value,
  prefix = "",
  prefixIndex = 0,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant={"h6"} className={classes.label}>
        {label}
      </Typography>
      <Select
        displayEmpty
        value={value}
        onChange={(e) => {
          const selectedOption = items.find(
            (item) => item.value === e.target.value
          );
          onChange(e.target.value, selectedOption.id);
        }}
        variant={"outlined"}
        className={classes.customSelect}
      >
        {items.map((item, ind) => {
          return (
            <MenuItem key={ind} value={item.value}>
              {item.name + (prefixIndex <= ind ? prefix : "")}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};

export default CustomComboBox;
